var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"outer-page"},[_c('div',{staticClass:"sub-banner"},[_c('img',{attrs:{"src":require("../../../../public/imgs/backgroundImg/01.jpg"),"alt":""}}),_c('div',{staticClass:"nav-bar"},[_c('nav-bar')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }